import { axios } from '@/utils/request'

const api = {
    _maType: "/PDM_MA_Type2"
}

export default api


/**
 * 创建预约套餐分类对象
 * @param {*} parameter 
 * @returns 
 */
export function CreatePDM_MA_TypeEntity(parameter) {
    return axios({
        url: api._maType + "/CreatePDM_MA_TypeEntity",
        method: 'post',
        data: parameter
    })
}

/**
 * 获取分类列表对象
 * @param {*} parameter 
 * @returns 
 */

export function GetPDM_MA_TypeList(parameter) {
    return axios({
        url: api._maType + "/GetPDM_MA_TypeList", 
        method: 'post', 
        data: parameter
    })
}

/**
 * 分页获取套餐分类对象
 * @param {*} parameter 
 * @returns 
 */
export function GetPDM_MA_TypeListByPage(parameter) {
    return axios({
        url: api._maType + "/GetPDM_MA_TypeListByPage", 
        method: 'post',
        data: parameter 
    })
}

/**
 * 获取套餐分类对象
 * @param {*} parameter 
 * @returns 
 */
export function GetPDM_MA_TypeEntity(parameter) {
    return axios({
        url: api._maType + "/GetPDM_MA_TypeEntity",
        method: 'post',
        data: parameter
    })
}
/**
 * 删掉套餐分类对象
 * @param {*} parameter 
 * @returns 
 */
export function DeletePDM_MA_TypeEntity(parameter) {
    return axios({
        url: api._maType + "/DeletePDM_MA_TypeEntity",
        method: 'post',
        data: parameter
    })
}
/**
 * 更新预约套餐分类对象
 * @param {*} parameter 
 * @returns 
 */
export function UpdatePDM_MA_TypeEntity(parameter) {
    return axios({
        url: api._maType + "/UpdatePDM_MA_TypeEntity",
        method: 'post',
        data: parameter
    })
}
/**
 * 设置套餐分类是否禁用
 * @param {*} parameter 
 * @returns 
 */

export function SetPDM_MA_TypeIsValid(parameter){
    return axios({
        url: api._maType + "/SetPDM_MA_TypeIsValid",
        method: 'post',
        data:parameter
    })
}
